import {
  TabList,
  Tabs
} from '@chakra-ui/react';
import { ShopDetailTabsPcItem } from './ShopDetailTabsPcItem';
import { ShopDetailTabsSpItem } from './ShopDetailTabsSpItem';
import { ReturnPageInfo } from '@/config/pages';

export type ShopDetailLinks = {
  menuLink: ReturnPageInfo;
  tabMenuTitle: string;
  tabIcon: string;
  activeTabIcon: string;
  spActiveTabIcon: string;
  spTabIcon: string;
  tabIconAlt: string;
}

type ShopDetailTabsProps = {
  activeIndex: number;
  shopDetailLinks: ShopDetailLinks[];
  isNullCourseFromShop: boolean;
  isNullStaffsFromShop: boolean;
  isNullMessageFromShop: boolean;
  isNullBlogFromShop: boolean;
}

export const ShopDetailTabs = ({
  activeIndex,
  shopDetailLinks,
  isNullCourseFromShop,
  isNullStaffsFromShop,
  isNullMessageFromShop,
  isNullBlogFromShop
}: ShopDetailTabsProps) => {
  // コンテンツがない時、タブのindexを指定する
  const disabledCourseIndex = isNullCourseFromShop ? 1 : '';
  const disabledStaffsIndex = isNullStaffsFromShop ? 2 : '';
  const disabledMessageIndex = isNullMessageFromShop ? 3 : '';
  const disabledBlogIndex = isNullBlogFromShop ? 4 : '';

  return (
    <>
      <Tabs
        display={{ base: 'none', lg: 'block' }}
        variant={'enclosed'}
        colorScheme={'white'}
      >
        <TabList>
          {shopDetailLinks.map(({
            menuLink,
            tabMenuTitle,
            tabIcon,
            activeTabIcon,
            tabIconAlt,
          }, index) => (
            <ShopDetailTabsPcItem
              key={index}
              isActive={activeIndex === index}
              isDisabledCourseTab={disabledCourseIndex === index}
              isDisabledStaffsTab={disabledStaffsIndex === index}
              isDisabledMessageTab={disabledMessageIndex === index}
              isDisabledBlogTab={disabledBlogIndex === index}
              tabIcon={tabIcon}
              tabIconAlt={tabIconAlt}
              activeTabIcon={activeTabIcon}
              menuLink={menuLink}
              tabMenuTitle={tabMenuTitle}
            />
          ))}
        </TabList>
      </Tabs>

      <Tabs
        display={{ base: 'block', lg: 'none' }}
        mt={-2}
        index={activeIndex}
        variant={'enclosed'}
        colorScheme={'white'}
        bg={'white'}
        px={{ base: 1, lg: 6 }}
      >
        <TabList>
          {shopDetailLinks.map(({
            menuLink,
            tabMenuTitle,
            spTabIcon,
            spActiveTabIcon,
            tabIconAlt
          }, index) => (
            <ShopDetailTabsSpItem
              key={index}
              isActive={activeIndex === index}
              isDisabledCourseTab={disabledCourseIndex === index}
              isDisabledStaffsTab={disabledStaffsIndex === index}
              isDisabledMessageTab={disabledMessageIndex === index}
              isDisabledBlogTab={disabledBlogIndex === index}
              menuLink={menuLink}
              tabIcon={spTabIcon}
              activeTabIcon={spActiveTabIcon}
              tabIconAlt={tabIconAlt}
              tabMenuTitle={tabMenuTitle}
            />
          ))}
        </TabList>
      </Tabs>
    </>
  );
};
